<template>
	<v-container>
			<div class="base-page">
				<div class="mx-3 mx-md-0">
				<v-row justify="center" class="pb-2 mt-2">
					<v-img src="/assets/clap-way-payment.png" max-width="250"></v-img>
				</v-row>
				<v-row justify="center" class="text-h3 textColor--text font-weight-bold">{{$t('payment.paymentPlans')}}</v-row>
				<v-row justify="center" class="text-h4 textColor--text">{{ project.subject }}</v-row>
				<div class="pt-4">
					<single-plan-component
						v-for="plan in plans"
						:key="plan.id"
						:custom-price="customPrice['custom'+plan.id]"
						:plan="plan"
						:active-plan-id="activePlan.id"
						:image="project.image"
						:can-select="plans.length > 1"
						@custom="setCustomPrice"
						@select="choosePlan"
					/>
				</div>
				<v-row class="py-3" justify="space-between" align="baseline">
					<div>
						<v-text-field id="coupon" hide-details v-model="coupon" class="mt-1 base-rounded" outlined
													name="coupon"
													:placeholder="$t('couponCode')" />
						<div v-if="couponError" class="red darken-2 text-center">
							<span class="white--text">{{ couponError }}</span>
						</div>
						<div v-if="usedCoupon" class="green darken-2 text-center">
							<span class="white--text">{{$t('payment.couponWasSuccessfullyRedeemed')}}</span>
						</div>
					</div>
					<div>
						<v-btn height="52px" block color="btnColor" class="text--white" @click="checkCoupon">
							<span class="py-3 coupon-text">{{$t('payment.applyCoupon')}}</span>
						</v-btn>
					</div>
				</v-row>
				<v-row v-if="activePlan" justify="space-between"
							 class="py-2 my-10 textColor--text price-row font-weight-bold">
					<div class="px-6">{{$t('payment.finalPrice')}}</div>
					<div class="px-6">{{ activePrice }}</div>
				</v-row>
				<v-row>
					<v-btn class="text--white font-weight-bold submit-button" type="submit" block @click="redirectToPayment"
								 rounded
								 color="btnColor">
						<span class="title-size">{{$t('payment.toPay')}}</span>
					</v-btn>
				</v-row>
					<lang-select />
				</div>
			</div>
	</v-container>
</template>

<script>
import ProjectModule from "@/store/modules/Project.module";
import PlanModule from "@/store/modules/Plan.module";
import SinglePlanComponent from "./SinglePlanComponent";
import { types } from "@/store/modules/Coupon.module";
import Button from "../../../resources/js/Jetstream/Button";
import LangSelect from "@/components/LangSelect";
export default {
	name: "PlansView",
	components: {
		LangSelect,
		SinglePlanComponent
	},
	data() {
		return {
			activePlan: "",
			testPlan: "",
			coupon: null,
			couponError: "",
			usedCoupon: false,
			customPrice: {},
		};
	},
	computed: {
		activePrice() {
			if (this.activePlan) {
				return this.activePlan.custom_price ? this.customPrice["custom" + this.activePlan.id] : this.activePlan.price;
			}
			return 0;
		},
		project() {
			return this.$store.state.ProjectModule.project;
		},
		plans() {
			return this.project.plans;
		},
		user() {
			return this.$store.state.AuthModule.user;
		}
	},
	watch: {
		plans: {
			immediate: true,
			handler() {
				if (this.project?.plans?.length === 1) {
					this.activePlan = this.project.plans[0];
				}

			}
		}
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(
				ProjectModule.types.GET,
				{ id, plan: this.$route.query.plan },
			);
		}
		console.log("plans");
		console.log(this.project.plans);

		this.activePlan = this.project.plans[0];

		this.project.plans.forEach((plan) => {
			if (plan.custom_price) {
				this.$set(this.customPrice, "custom" + plan.id, plan.price);
			}
		});
		// await this.$store.dispatch(TrackModule.types.SAVE, {
		// 	project: this.project.id
		// });

	},
	methods: {
		setCustomPrice({ plan, custom }) {
			this.$set(this.customPrice, "custom" + plan, custom);
		},
		choosePlan(plan) {
			this.activePlan = plan;
		},
		savePlanInLocalStorage() {
			sessionStorage.setItem("activeProject", this.$route.query.p);
			sessionStorage.setItem("activePlan", this.activePlan.id);
			this.testPlan = sessionStorage.getItem("activePlan");
		},
		saveQueryInLocalStorage() {
			window.localStorage.setItem(
				"queryString",
				JSON.stringify(this.$route.query)
			);
		},
		saveCouponInLocalStorage() {
			window.localStorage.setItem("coupon", this.coupon);
		},
		async redirectToPayment() {
			if (this.activePlan.id) {
				this.savePlanInLocalStorage();
				this.saveQueryInLocalStorage();
				this.saveCouponInLocalStorage();
				const response = await this.$store.dispatch(
					PlanModule.types.GET_PAYMENT_URL,
					{
						id: this.activePlan.id,
						coupon: this.coupon,
						custom: this.customPrice["custom" + this.activePlan.id]
					}
				);
				window.location = response.url;
			} else {
				// this.$router.push({ name: 'thank-you-page' })
			}
		},
		checkCoupon() {
			if (this.coupon && !this.usedCoupon) {
				this.$store
					.dispatch(types.CHECK_COUPON, {
						code: this.coupon,
						userId: this.user.id
					})
					.then(response => {
						if (response.discount) {
							this.couponError = "";
							this.project.plans.forEach(plan => {
								const currentPrice = plan.price;
								if (response.type === "fixed") {
									const newPrice = currentPrice - response.discount;
									plan.price = newPrice > 0 ? newPrice : 0;
								} else {
									const precentCalculation =
										(response.discount * currentPrice) / 100;
									const newPrice = currentPrice - precentCalculation;
									plan.price = newPrice > 0 ? newPrice : 0;
								}
							});
							this.usedCoupon = true;
						} else {
							this.couponError = response.error;
						}
					});
			}
		},
	}
};
</script>

<style lang="scss" scoped>


.page {
	&__cuppon {
		color: white;
		margin-top: 5vh;
	}
}

.coupon-btn {
	height: 60px;
}

.price-row {
	font-size: 24px;
	border-top: 1px solid #518CE3; /* Top border */
	border-bottom: 1px solid #518CE3; /* Bottom border */
}

.submit-button {
	.text {
		font-size: 1.5rem;
	}
}

.coupon-text {
	font-size: 1.25rem;
}

</style>
